import { memo } from 'react';

import { SVGType } from '../types';

export const IslandTravelUmbrellaIcon = memo(({ stroke, size = 24, ...rest }: SVGType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 24 24" {...rest}>
    <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#clip0_3410_39335)">
      <path d="M12.184 11.51l-2.551 6.017M15.541 3.584a7.314 7.314 0 014.178 8.734l-.066.232a1.746 1.746 0 01-2.361 1.13L7.064 9.338a1.746 1.746 0 01-.828-2.484l.121-.21a7.315 7.315 0 019.184-3.06v0z"></path>
      <path d="M15.543 3.582l.226.916a9.32 9.32 0 01-1.609 7.85v0M15.541 3.582l-.816.473a9.322 9.322 0 00-4.53 6.611v0M3 20.001a8.5 8.5 0 0112.02 0"></path>
    </g>
    <defs>
      <clipPath id="clip0_3410_39335">
        <path fill="#fff" d="M0 0H24V24H0z"></path>
      </clipPath>
    </defs>
  </svg>
));

export default IslandTravelUmbrellaIcon;
